/**
 * beszélget a mifid trezsörivel
 */
import axios from 'axios';
const mifidBackendUrl = '/apps/mifid/api';
export default {
	getMasterData(selectedValues) {
		return axios.post(mifidBackendUrl + '/data/treasury', selectedValues);
	},
	calculate(selectedValues) {
		return axios.post(mifidBackendUrl + '/calculator/treasury', selectedValues);
	}
};
